<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="72"
    height="47"
    viewBox="0 0 72 47"
  >
    <defs>
      <clipPath id="a">
        <rect class="a" width="72" height="47" />
      </clipPath>
    </defs>
    <g class="b" :fill="fill">
      <g>
        <rect class="a" width="5.464" height="5.508" transform="translate(17.64 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(17.64 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(17.64 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762 35.566)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(17.64 41.492)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(23.519 41.492)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(5.879 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(5.879 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(0 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(0 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(0 35.566)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(23.519 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(23.519 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(23.519 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(23.519 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(29.402 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(29.402 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(29.402 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(29.402 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(52.921 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(35.28 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(35.28 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 17.783)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(35.28 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(35.28 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 35.566)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(58.799 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042 35.566)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(41.159 41.492)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(35.28 41.492)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(58.799 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(52.921 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(58.799 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(58.799 35.566)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(41.159 11.857)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(41.159 23.709)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(41.159 29.64)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(17.64 5.926)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(41.159 5.926)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(11.762)" />
        <rect class="a" width="5.464" height="5.508" transform="translate(47.042)" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Alive",
  props: {
    fill: {
      type: String,
      default: "#ab90c9"
    }
  }
};
</script>

<style lang="scss" scoped>
.a {
  // fill: #ab90c9;
}
.b {
  opacity: 0.727;
}
</style>